module.exports = "<div class=\"container\">\n  <a routerLink=\"/\" class=\"btn btn-link\"><i class=\"fa fa-arrow-circle-o-left\"></i>  Back to Home page</a>\n  <br>\n  <br>\n  <h1>PAGE NOT FOUND!</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-not-found/page-not-found.component.html
// module id = ./src/app/components/page-not-found/page-not-found.component.html
// module chunks = main